import { useContext } from 'react';
import { dependenciesFieldPathsContext } from './context';

export const useDependenciesFieldPaths = () => {
  const dependenciesFieldPaths = useContext(dependenciesFieldPathsContext);
  return dependenciesFieldPaths;
};
